// CatGroomingPreferences.jsx
import React from 'react';

const CatGroomingPreferences = ({ groomingBookingData, setGroomingBookingData }) => {
  var opts = groomingBookingData && groomingBookingData.groomingOptions ? groomingBookingData.groomingOptions : {};
  var selectedAdditional = opts.additionalServices || [];
  var selectedStyle = opts.selectedHaircutStyle || '';
  var selectedStyleImage = opts.selectedStyleImage || null;

  function setGO(patch) {
    setGroomingBookingData(function(prev){
      var next = Object.assign({}, prev || {});
      var go = next.groomingOptions ? Object.assign({}, next.groomingOptions) : {};
      var key;
      for (key in patch) { go[key] = patch[key]; }
      next.groomingOptions = go;
      return next;
    });
  }

  function handleStyle(style) {
    setGO({ selectedHaircutStyle: style, selectedStyleImage: null });
  }

  function toggleAdditional(service) {
    var updated = selectedAdditional.slice(0);
    var idx = -1;
    var i = 0;
    while (i < updated.length) {
      if (updated[i] === service) { idx = i; break; }
      i++;
    }
    if (idx >= 0) { updated.splice(idx, 1); } else { updated.push(service); }
    setGO({ additionalServices: updated });
  }

  function isSelected(service) {
    var i = 0;
    while (i < selectedAdditional.length) {
      if (selectedAdditional[i] === service) return true;
      i++;
    }
    return false;
  }

  function toggleCondition(key) {
    setGroomingBookingData(function(prev){
      var next = Object.assign({}, prev || {});
      var go = next.groomingOptions ? Object.assign({}, next.groomingOptions) : {};
      var current = go[key] ? true : false;
      go[key] = !current;
      next.groomingOptions = go;
      return next;
    });
  }

  function isConditionSelected(key) {
    return groomingBookingData &&
           groomingBookingData.groomingOptions &&
           groomingBookingData.groomingOptions[key] ? true : false;
  }

  // Cat included list (no anal glands; no dog-only items)
  var included = [
    'Breed/Owner-Requested Haircut',
    'Sanitary Trim',
    'Pad Shave',
    'Nail Trim & File',
    'Bath & Gentle Dry',
    'Brush Out / De-mat as approved',
    'Ear Cleaning',
    'Paw Balm'
  ];

  // Style choices for cats (includes Cut Style)
  var styleButtons = [
    { key: 'summer',  label: 'Short & Neat (Summer)' },
    { key: 'lion',  label: 'Lion Cut' },
    { key: 'teddy', label: 'Teddy Cut' },
  ];

  // Cat add-ons (no teeth brushing for cats)
  var addOns = [
    { key: 'deshedding', label: 'De-Shedding' },
    { key: 'fleaTick',  label: 'Flea & Tick Treatment' }
  ];

  return (
    <div className="grooming-preferences">
      <h3>What’s included for cats?</h3>
      <ul>
        {included.map(function(item, i){ return <li key={i}>{item}</li>; })}
      </ul>

      <h3>Special Conditions</h3>
      <div className="special-conditions">
        <button
          className={'condition-button ' + (isConditionSelected('mattedHair') ? 'selected' : '')}
          onClick={function(){ toggleCondition('mattedHair'); }}
          type="button"
        >
          Matted Hair (De-matting)
        </button>
        <button
          className={'condition-button ' + (isConditionSelected('sensitiveSkin') ? 'selected' : '')}
          onClick={function(){ toggleCondition('sensitiveSkin'); }}
          type="button"
        >
          Sensitive Skin (Hypoallergenic)
        </button>
      </div>

      <h3>Grooming Preferences</h3>
      <div className="haircut-style">
        <div className="style-buttons">
          {styleButtons.map(function(s){
            return (
              <button
                key={s.key}
                className={'style-button ' + (selectedStyle === s.key ? 'selected' : '')}
                onClick={function(){ handleStyle(s.key); }}
                type="button"
              >
                {s.label}
              </button>
            );
          })}
        </div>
      </div>

      <h3>Additional Services</h3>
      <div className="additional-services">
        {addOns.map(function(a){
          return (
            <button
              key={a.key}
              className={'service-button ' + (isSelected(a.key) ? 'selected' : '')}
              onClick={function(){ toggleAdditional(a.key); }}
              type="button"
            >
              {a.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CatGroomingPreferences;
